export default __webpack_public_path__ + "static/media/gscholar.7431f663.png";